import React from 'react'
import { useRouter } from 'next/router'
import { useTrans } from 'hooks'
import { PaginaNode, VideoTutorialNode } from '@gql/graphql'
import { PlaceholderReact } from '@components/molecules'
import {
  NewsletterSection,
  Page,
  VideoTutorialCorrelati,
  VideoTutorialHead,
} from 'components/organisms'
import styles from './VideoTutorialDetailTemplate.module.sass'
import { WContainer } from '@components/atoms'

interface Props {
  pagina?: PaginaNode
  videoTutorial?: VideoTutorialNode
  mainContent?: any
}

const VideoTutorialDetailTemplate = (props: Props) => {
  const { pagina = undefined, videoTutorial = undefined, mainContent = undefined } = props

  const t = useTrans()
  const router = useRouter()
  const newsletterItem = {
    name: t(`newsletter_section_title_${process.env.SITE_ID}_${router.locale}`),
    description: t(`newsletter_section_description_${process.env.SITE_ID}_${router.locale}`),
  }

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main className={styles.layout}>
        <VideoTutorialHead pagina={pagina} videoTutorial={videoTutorial} />
        <div className={styles.content}>
          <PlaceholderReact
            contentTypeId={videoTutorial.model}
            objectId={videoTutorial.pk}
            pkey={'main'}
            serverSideContent={mainContent}
          />
        </div>
        <WContainer>
          <NewsletterSection item={newsletterItem} />
        </WContainer>
        <VideoTutorialCorrelati
          title={t('Video correlati')}
          videoTutorial={videoTutorial.correlati}
        />
      </main>
    </Page>
  )
}

export default VideoTutorialDetailTemplate
